// web/src/features/competition/wizard/hooks/useCloneCompetition.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  cloneCompetition,
  ClonedCompetition,
} from '@sportninja/common/services/competition'
import type { CloneCompetitionRequest } from '@sportninja/common/features/competition/wizard/types'
import { queryKeys } from '@sportninja/common/config/queryKeys'

type Vars = {
  sourceScheduleId: string
  body: CloneCompetitionRequest
  orgId: string
}

export const useCloneCompetition = () => {
  const queryClient = useQueryClient()
  return useMutation<ClonedCompetition, Error, Vars>({
    mutationFn: ({ sourceScheduleId, body }) =>
      cloneCompetition(sourceScheduleId, body),
    // Override the global mutations.retry=1 default (see queryClient config).
    // Clone is non-idempotent — a retry can silently duplicate the schedule.
    retry: 0,
    onSuccess: (_data, { orgId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.orgCompetitions.byOrg(orgId),
      })
    },
  })
}
